import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DeepLinkRedirect from './pages/DeepLinkRedirect';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import GuidelinesPage from './pages/GuidelinesPage';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Main landing page */}
                <Route path="/" element={<HomePage />} />

                {/* Legal pages */}
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/guidelines" element={<GuidelinesPage />} />

                {/* Deep link routes */}
                <Route path="/video/:id" element={<DeepLinkRedirect type="video" />} />
                <Route path="/profile/:id" element={<DeepLinkRedirect type="profile" />} />
                <Route path="/dare/:id" element={<DeepLinkRedirect type="dare" />} />

                {/* Fallback to homepage for unknown routes */}
                <Route path="*" element={<HomePage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
